import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  invoices: {
    data: [],
    queryParams: {
      pageNum: 1,
      pageSize: 25,
      sortBy: 'datum',
      sortDesc: true,
      query: null,
      customerId: null,
    },
    loading: false,
    tableHeadings: {
      dobavljac: {
        title: 'Dobavljač',
        sortBy: false,
        sortDesc: true,
      },
      broj: {
        title: 'Broj',
        sortBy: false,
        sortDesc: true,
      },
      datum: {
        title: 'Datum',
        sortBy: true,
        sortDesc: true,
      },
    },
    missingInvoiceModal: {
      show: false,
      loading: false,
    },
  },
  invoice: {
    info: {},
    data: [],
    filteredData: [],
    pageData: [],
    queryParams: {
      pageNum: 1,
      pageSize: 30,
    },
    loading: false,
    tableHeadings: {
      sifra: {
        title: 'Lokalna šifra',
      },
      ean: {
        title: 'Ean',
      },
      naziv: {
        title: 'Naziv',
      },
      proizvodjac: {
        title: 'Proizvođač',
      },
      jedinicaMere: {
        title: 'Jedinica mere',
      },
      kolicina: {
        title: 'Kolicina',
      },
    },
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
